import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.Colors)
@ComponentConfigurationClass("colors")
export class ColorsConfiguration {

    /**
     * @format color
     */
    public primaryColor?: string;
    /**
     * @format color
     */
    public secondaryColor?: string;
}
